export const GET_POLICIES = "GET_POLICIES";
export const GET_POLICIES_SUCCESS = "GET_POLICIES_SUCCESS";
export const GET_POLICIES_API_ERROR = "GET_POLICIES_API_ERROR";

export const GET_POLICIE = "GET_POLICIE";
export const GET_POLICIE_SUCCESS = "GET_POLICIE_SUCCESS";